import { queryOptions } from '@tanstack/react-query'
import { apiClient } from '.'
import type { LanguagesConfig } from './types'

export const languagesQuery = queryOptions({
  queryKey: ['languages'],
  queryFn: () => fetchLanguages(),
})

async function fetchLanguages(): Promise<LanguagesConfig> {
  return apiClient.get(`/languages`).then((res) => res.data)
}
